import { all } from 'redux-saga/effects';
import Settings from './settings/sagas';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function* rootSaga() {
  yield all([Settings()]);
}
